module.exports = __webpack_public_path__ + "static/img/caoxi.0d6c360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/caoxi.png
// module id = ze9+
// module chunks = 0